import { render, staticRenderFns } from "./MasterGoal.vue?vue&type=template&id=fc0210a8&"
import script from "./MasterGoal.vue?vue&type=script&lang=js&"
export * from "./MasterGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports